__turbopack_context__.v({
  "comparisonList": "prosAndCons-module-scss-module__UurVBG__comparisonList",
  "comparisonTitle": "prosAndCons-module-scss-module__UurVBG__comparisonTitle",
  "cons": "prosAndCons-module-scss-module__UurVBG__cons",
  "header": "prosAndCons-module-scss-module__UurVBG__header",
  "pros": "prosAndCons-module-scss-module__UurVBG__pros",
  "prosCons": "prosAndCons-module-scss-module__UurVBG__prosCons",
  "prosConsContainer": "prosAndCons-module-scss-module__UurVBG__prosConsContainer",
});
